export const generateInteractions = (craftJsSchema: Record<string, any>) =>
	Object.keys(craftJsSchema).flatMap<{
		id: string;
		label: string;
		icon: string;
	}>((id) => {
		const item = craftJsSchema[id];

		switch (true) {
			// buttons
			case item.custom?.type === 'button':
				return [
					{
						id,
						label: item.props.children,
						icon: item.props.startIcon,
						subType: item.custom?.subType
					}
				];

			// webauthn autocomplete
			case item.custom?.type === 'input' &&
				item.props.autoComplete === 'webauthn':
				return [
					{
						id,
						label: item.props.label,
						icon: 'fingerprint',
						subType: item.custom?.subType
					}
				];

			// magic/enchanted link polling
			case item.custom?.type === 'polling':
				return [
					{
						id: 'polling',
						label: 'Polling',
						icon: undefined,
						subType: item.custom?.subType
					}
				];

			default:
				return [];
		}
	});
